export default __webpack_public_path__ + "static/media/promo-banner-freezer.56adb15c.svg";